var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mtd-date-picker',{attrs:{"type":"datetime","disabled":_vm.disabled,"readonly":_vm.readonly},on:{"input":_vm.valueChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }